













import {Component, Prop, Vue} from "vue-property-decorator";
import Notification from "@/consoleapi/api/notification";

@Component
export default class NotificationIndex extends Vue {
    public notifications = [];

    mounted(): void {
        this.getNotification();
    }

    getNotification(){
        const notification = new Notification();
        notification.get().then(response => {
            // console.log(response.data);
            this.notifications = response.data.notifications;
        }).catch(error => {
            //console.log(error.response);
        });
    }
}
